import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { FaUser, FaSignOutAlt, FaSun, FaMoon } from 'react-icons/fa';
// TEMA NATALIZIO ARCHIVIATO - Per riattivare: decommentare la riga seguente
// import { GiPineTree } from 'react-icons/gi';
import MusicPlayer from '../components/common/MusicPlayer';

const Header = () => {
  const { user, logout } = useAuth();
  const { theme, toggleTheme, THEMES } = useTheme();

  const handleLogout = () => {
    logout();
  };

  // Determina icona e label in base al tema corrente
  const getThemeIcon = () => {
    if (theme === THEMES.LIGHT) return <FaSun size={16} />;
    if (theme === THEMES.DARK) return <FaMoon size={16} />;
    // TEMA NATALIZIO ARCHIVIATO - Per riattivare: decommentare la riga seguente
    // if (theme === THEMES.CHRISTMAS) return <GiPineTree size={16} />;
    return <FaSun size={16} />;
  };

  const getThemeLabel = () => {
    if (theme === THEMES.LIGHT) return 'Light';
    if (theme === THEMES.DARK) return 'Dark';
    // TEMA NATALIZIO ARCHIVIATO - Per riattivare: decommentare la riga seguente
    // if (theme === THEMES.CHRISTMAS) return 'Christmas';
    return 'Theme';
  };

  return (
    <header className={`${
      theme === 'dark' 
        ? 'bg-gray-800 border-gray-700' 
        : 'bg-white border-gray-200'
    } border-b px-6 py-4 flex justify-between items-center fixed top-0 left-16 right-0 z-30`}>
      
      {/* Titolo/Breadcrumb - SPOSTATO PIÙ A SINISTRA */}
      <div className="flex items-center ml-2"> {/* RIDOTTO DA ml-8 A ml-2 */}
        <h1 className={`text-xl font-semibold ${
          theme === 'dark' ? 'text-white' : 'text-gray-900'
        }`}>
          SiSketron 2
        </h1>
      </div>

      {/* Azioni Header - MANTIENI COSÌ */}
      <div className="flex items-center space-x-4 mr-8">
        {/* Music Player */}
        {/* TEMA NATALIZIO ARCHIVIATO - Per riattivare: ripristinare isChristmasTheme={theme === THEMES.CHRISTMAS} */}
        <MusicPlayer isChristmasTheme={false} />

        {/* Toggle Tema */}
        {/* TEMA NATALIZIO ARCHIVIATO - Per riattivare: ripristinare il ternary con theme === 'christmas' */}
        <button
          onClick={toggleTheme}
          className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
            theme === 'dark'
              ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              // : theme === 'christmas'
              // ? 'bg-green-700 text-white hover:bg-green-600'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
          title={`Tema corrente: ${getThemeLabel()}. Clicca per cambiare`}
        >
          {getThemeIcon()}
          <span className="text-sm font-medium">{getThemeLabel()}</span>
        </button>

        {/* Info Utente */}
        {user && (
          <div className="flex items-center space-x-2">
            <FaUser className="text-gray-500" size={16} />
            <span className={`text-sm ${
              theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
            }`}>
              {user.UTE_NomeUtente || user.username}
            </span>
          </div>
        )}

        {/* Logout */}
        <button
          onClick={handleLogout}
          className="flex items-center space-x-2 px-3 py-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
          title="Disconnetti"
        >
          <FaSignOutAlt size={16} />
          <span className="text-sm">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;